module.exports = {"head":{"title":"Liste des 11"},"CTA":{"validate":"Valider","start":"Commencer","restart":"Recommencer"},"section":{"select":"Sélectionnez","step":"Étape {from}/{to}"},"result":{"title":"Votre équipe type pour la Coupe du Monde 2026","nav":{"myResult":"Votre sélection","otherResult":"Sélection des internautes"}},"stats":{"units":{"nAge":"ans","nHeight":"m","nWeight":"kg"},"subtitles":{"nAge":"Moyenne d'âge","nHeight":"Taille moyenne","nWeight":"Poids moyen"}}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/fr.json
// module id = kV3b
// module chunks = 1